// extracted by mini-css-extract-plugin
module.exports = {"productcontent":"single-axis-solar-tracker_productcontent__iBGtm"};